import styled from '../../../../style/styled';

export const ContentSectionWidgetNewContainer = styled.div<{
  interactive: boolean;
}>`
  text-align: center;
  position: relative;
  cursor: ${({ interactive }) => (interactive ? 'pointer' : 'auto')};
  overflow: hidden;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  max-width: 393px;
  border: 1px solid #ccc;
  height: 100%;
  //filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  &:hover {
    transform: scale(1.01);
    border: 1px solid #000000;
  }
`;
